import Right from './Right.vue'
import addRight from './addRight.vue'
import seeRight from './seeRight.vue'
import modifyRight from './modifyRight.vue'
import passRight from './passRight.vue'

export default{
	Right,
	addRight,
	seeRight,
	modifyRight,
	passRight
}


// WEBPACK FOOTER //
// ./src/components/rightsApp/index.js